<template>
  <div :class="['filter-container filter-container-state flex-row', dbOptionHeight]">
    <div class="filter-value flex flex-center filter-checkbox">
      <ms-checkbox v-model="filterValue" @change="updateAllState" />
    </div>
  </div>
</template>
<script>
import { defineComponent, inject, getCurrentInstance, onMounted, watch } from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import msValidate from '@/components/validate/MsValidate.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';

export default defineComponent({
  name: 'MsThOptionState',
  extends: msThOptionBase,
  components: {
    msValidate,
    MenuItem,
    MenuWrapper,
  },
  props: {
    col: {
      default: {},
      type: Object,
    },
    colValue: {
      default: false,
      type: Boolean,
    },
    dbOptionHeight: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const {
      nativeFilterIconClass,
      tooltipIcon,
      operatorValue,
      filterOperators,
      filterHeaderHandle,
      removeFilter,
      filterValue,
      filterOperatorItemClick,
    } = setup(props, { emit });

    //Hooks
    //Inject hàm update all state
    const update = inject('updateAllState');
    const updateAllState = value => {
      update(props.col.stateField, value);
    };

    onMounted(() => {
      proxy.filterValue = props.colValue;
    });

    watch(
      () => props.colValue,
      val => {
        proxy.filterValue = val;
      }
    );

    return {
      nativeFilterIconClass,
      operatorValue,
      filterOperators,
      filterValue,
      filterHeaderHandle,
      removeFilter,
      filterOperatorItemClick,
      updateAllState,
    };
  },
});
</script>
<style lang="scss">
.ms-th-filter {
  .filter-container-state {
    display: flex;
    justify-content: center;
  }
}
.filter-container-state {
  .filter-checkbox {
    .ms-checkbox {
      margin-right: unset !important;
      margin-left: 20px !important;
    }
  }
}

.filter-container-state {
  background: #fff;
}
</style>
